<template>
    <div class="animated fadeIn">
        <DynamicList
                ref="dynamicCardList"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                :onRetrieve="onRetrieve"
                root="/report/event-visits"
                :searchArgs="searchArgs">

            <slot slot="afterSearchForm">
                <b-button @click="$refs.modalExport.open = true" variant="light" class="mb-3">
                    {{Core.Definition.getDefinition("Exporter sous format ...")}}
                </b-button>
                <ModalExport
                        ref="modalExport"
                        root="/report/event-visits"
                        :formStructure="{
                                rows: [
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportFormat'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                     {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'userFirstname'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'userLastname'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'userPhone'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'userEmail'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'visitCount'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'presentCount'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'absenceCount'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'visitLastDate'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                fields: [
                                    {
                                        id: 'exportFormat',
                                        type: 'select',
                                        options: Core.Export.formatOptions(),
                                        label: Core.Definition.getDefinition('Format'),
                                        value: null,
                                        onSelect: function() {}
                                    },
                                    {
                                        id: 'exportTitle',
                                        type: 'text',
                                        label: Core.Definition.getDefinition('Titre'),
                                        value: '',
                                        required: true
                                    },
                                    {
                                        id: 'userFirstname',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Prénom'),
                                        value: true,
                                         export: 'userFirstname',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'userLastname',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Nom de famille'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'userLastname',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'userPhone',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Téléphone'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'userPhone',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'userEmail',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Courriel'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'userEmail',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'visitCount',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Nombre de visites'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'visitCount',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'presentCount',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Nombre de présences'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'presentCount',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'absenceCount',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Nombre d\'absences'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'absenceCount',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'visitLastDate',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Dernière visite'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'visitLastDate',
                                        onChange: function() {}
                                    }
                                ]}"

                @onSubmit="onExport">
                </ModalExport>
            </slot>
        </DynamicList>

    </div>
</template>

<script>
    import DynamicList from '../../../../components/DynamicList'
    import CardChartBar from '../../../../components/CardChartBar'
    import ModalExport from '../../../../components/ModalExport'
    export default {
        name: 'ReportEventBooking',
        components: {
            DynamicList,
            CardChartBar,
            ModalExport
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataSearchArgs: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('Prénom'),
                        key: 'userFirstname',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom de famille'),
                        key: 'userLastname',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Visite(s)'),
                        key: 'visitCount',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Présence(s)'),
                        key: 'presentCount',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Absence(s'),
                        key: 'absenceCount',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Dernière visite'),
                        key: 'visitLastDate',
                        type: 'date',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'eventDateStart'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'eventDateEnd'
                                        }
                                    ]
                                },
                                {}, {}
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'userFirstname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'userLastname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'userEmail'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'userPhone'
                                        }
                                    ]
                                }
                            ]
                        },
                    ],
                    fields: [
                        {
                            id: 'eventDateStart',
                            type: 'date',
                            label: Core.Definition.getDefinition('Début'),
                        },
                        {
                            id: 'eventDateEnd',
                            type: 'date',
                            label: Core.Definition.getDefinition('Fin'),
                        },
                        {
                            id: 'userFirstname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Prénom'),
                            value: ''
                        },
                        {
                            id: 'userLastname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Nom de famille'),
                            value: ''
                        },
                        {
                            id: 'userPhone',
                            type: 'text',
                            label: Core.Definition.getDefinition('Téléphone'),
                            value: ''
                        },
                        {
                            id: 'userEmail',
                            type: 'text',
                            label: Core.Definition.getDefinition('Courriel'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                }
            }
        },
        methods: {
            onExport() {
                let searchArgs = this.$refs.dynamicCardList.$refs.request.dataArgs
                for(let searchArg in searchArgs) {
                    searchArg = searchArgs[searchArg]
                    this.$refs.modalExport.$refs.request.addArg(searchArg.key, searchArg.value, searchArg.type)
                }
            },
            onRetrieve(data) {
            },
            clickEdit(value, cell, row) {
                this.$router.push(Core.Text.format(Core.Definition.getDefinition('/evenement/reservations/{0}/{1}'), row.eventDateStart, row.eventDateId))
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
